import { Address } from 'features/Directory'
import { isNil, sumBy } from 'lodash-es'
import moment from 'moment'
import { FC } from 'react'
import { formatNumber } from 'service/NumberFormatter'
import { DateFormatMoment } from 'utils/date'
import { useI18n } from 'utils/localisation'

import { TTransportModeWithShip } from '../QuoteSheet/QuoteOption/QuoteTransportPlan'
import { IQuoteOption, Route } from '../QuoteSheet/QuoteSheetOption'
import { BookingTimelineItem } from './BookingTimelineItem'

type PostRouteScheduleProps = {
  option: IQuoteOption
}

export const getRouteDistance = (route: Route): string => {
  if (route.distance == null) return ''
  return `${formatNumber(route.distance / 1000, 2)} km`
}

export const PostRouteSchedule: FC<PostRouteScheduleProps> = ({ option }) => {
  const { translate } = useI18n()

  const { preQuote, mainQuote, postQuote } = option.routeQuotes
  const totalDuration = sumBy([preQuote, mainQuote, postQuote], (route) => route?.route.duration || 0)

  if (isNil(postQuote)) {
    return null
  }

  const {
    route: { journey },
  } = postQuote

  return (
    <>
      <BookingTimelineItem
        icon={postQuote.mode as TTransportModeWithShip}
        timelineContent={{
          description: {
            label: `${postQuote.mode} ${translate('quote_sheet-option-transport_plan-post_run-on_carriage')}`,
            value: getRouteDistance(postQuote.route),
          },
        }}
      />
      <BookingTimelineItem
        isLastLeg
        timelineContent={{
          timestamp: {
            label: translate('quote_sheet-option-transport_plan-estimated_delivery'),
            value: moment(mainQuote.route.eta).add(totalDuration).format(DateFormatMoment.DATE),
          },
          description: {
            label: translate('quote_sheet-option-transport_plan-destination'),
            value: (journey.destination as Address).city ?? '-',
          },
        }}
      />
    </>
  )
}
